import type { MembershipDueStatus } from '@zetyar/domain'
import { Badge } from '@/presentation/components/ui/Badge'

/** `null` means nothing is registered for that month: the due is pending. */
export function DueStatusBadge({ status }: { readonly status: MembershipDueStatus | null }) {
  if (status === 'paid') return <Badge variant="success">Pagada</Badge>
  if (status === 'exempt') return <Badge variant="neutral">Exenta</Badge>
  if (status === 'processing') return <Badge variant="info">En proceso</Badge>
  return <Badge variant="warning">Pendiente</Badge>
}
